export function transformDatenqualitaet(value: number): string {
    if (typeof value === 'number') {
        if (value >= 1 && value <= 1.49) {
            return 'Sehr gut';
        } else if (value >  1.49 && value <= 2.49) {
            return 'Befriedigend';
        } else if (value > 2.49 && value <= 3) {
            return 'Schlecht';
        }
    }

    return ' - ';
}
